import logoImage from "./svg/logo.svg";
import userImage from "./svg/user.svg";
import avatar from "./svg/avatar.svg";

export const LogoImage = logoImage;
export const UserImage = userImage;
export const Avatar = avatar;

export * from "./Icons";
